<template>
  <div class="page_box">
    <div class="page_option_box ">
      <div class="option_box ">
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-circle-plus-outline"
          @click="add"
        >
          新增
        </el-button>
        <el-button
          type="danger"
          plain
          size="mini"
          icon="el-icon-circle-close"
          :disabled="selectedDataList.length == 0 ? true : false"
          @click="delBath"
        >
          删除
        </el-button>
      </div>
      <div class="search_box">
        <el-select
          v-model="requestData.diningId"
          placeholder="请选择"
          size="mini"
        >
          <el-option
            v-for="item in canteenList"
            :key="item.id"
            :label="item.diningRoomName"
            :value="item.id.toString()"
          >
          </el-option>
        </el-select>
        <el-date-picker
          size="mini"
          v-model="selectDate"
          align="right"
          type="date"
          placeholder="选择日期"
          value-format="timestamp"
          :picker-options="pickerOptions"
          @change="selDate"
        >
        </el-date-picker>
        &nbsp;
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchData"
        >
          搜索
        </el-button>
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="selectActionData"
        >
          <el-table-column type="selection" width="36"> </el-table-column>
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>

          <el-table-column
            prop="sampleFoodName"
            label="留样名称"
            align="center"
          >
          </el-table-column>

          <el-table-column prop="sampleQuantity" label="留样量" align="center">
          </el-table-column>

          <el-table-column
            prop="sampleStorageLocation"
            label="样品存放地点"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="sampleTime"
            label="留样时间"
            width="96"
            align="center"
          >
            <template v-slot="scope">
              {{ $Common.dateFormatDate(scope.row.sampleTime) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="retentionSamplesAre"
            label="留样人"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="leaveSampleNumber"
            label="留样联系人电话"
            width="120"
          >
          </el-table-column>

          <el-table-column label="操作" width="180" align="center">
            <template v-slot="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="edit(scope.row)"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="del(scope.row.id)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>
    <sample-management-operate
      :operateResize="operateResize"
      :drawerType="drawerType"
      :editData="editData"
      @getList="getSampleList"
    ></sample-management-operate>
  </div>
</template>

<script>
import sampleManagementOperate from "./sampleManagementOperate";
export default {
  name: "sampleManagementList",
  components: {
    sampleManagementOperate
  },
  props: {},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      selectDate: null,
      requestData: {
        diningId: "",
        pageSize: 20,
        pageNum: 1,
        sampleTime: ""
      },
      responseData: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
        pages: 0,
        list: []
      },
      selectedDataList: [],
      operateResize: 0,
      drawerType: "",
      editData: {},
      canteenList: []
    };
  },
  created() {},
  mounted() {
    this.getCanteenList();
  },
  computed: {},
  watch: {},
  methods: {
    async getCanteenList() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getCanteenCameraCanteenList(req);
      if (res.code == 200) {
        this.canteenList = res.data || [];
        if (this.canteenList.length > 0) {
          this.requestData.diningId = this.canteenList[0].id.toString();
        }
        this.getSampleList();
      } else if (res.code == 101) {
        this.canteenList = [];
        this.requestData.diningId = "";
        this.responseData.list = [];
        this.requestData.total = 0;
      } else {
        this.canteenList = [];
        this.requestData.diningId = "";
        this.responseData.list = [];
        this.requestData.total = 0;
        this.$message({
          type: "info",
          message: res.messsage
        });
      }
    },
    selectActionData(selectData) {
      this.selectedDataList = [];
      selectData.forEach((element) => {
        this.selectedDataList.push(element.id);
      });

      // console.log(this.selectedDataList);
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.getSampleList();
    },
    selDate() {
      if (this.selectDate) {
        this.requestData.sampleTime = this.selectDate / 1000;
      } else {
        this.requestData.sampleTime = "";
      }
    },

    add() {
      this.drawerType = "add";
      this.operateResize++;
    },
    edit(row) {
      // console.log(row);
      this.drawerType = "edit";
      this.editData = row;
      this.operateResize++;
    },
    del(id) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.selectedDataList = [id];
          this.delSample();
        })
        .catch(() => {});
    },
    delBath() {
      if (this.selectedDataList.length <= 0) {
        this.$message("请先选择要删除的数据！");
        return;
      }
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delSample();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    searchData() {
      this.requestData.pageNum = 1;
      this.getSampleList();
    },
    // 留样记录展示
    async getSampleList() {
      let req = this.requestData;
      let res = await this.$Http.getSampleList(req, true);
      if (res.code == 200) {
        this.responseData = res.data;
      } else if (res.code == 101) {
        this.responseData.list = [];
        this.responseData.total = 0;
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 删除留样记录
    async delSample() {
      let req = {
        sampleId: this.selectedDataList
      };
      let res = await this.$Http.delSample(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.getSampleList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style scoped>
.content {
  height: calc(100% - 54px);
}
.content_top_three {
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: space-between;
}
.content_center_three {
  height: 76%;
}
</style>
